import { useState, useEffect, useCallback } from 'react';

const VERSION_STORAGE_KEY = 'app_build_number';
const CHECK_INTERVAL = 3 * 60 * 1000; // 3 minutos
const AUTO_RELOAD_DELAY = 2000; // 2 segundos para mostrar notificação

export const useAppVersion = () => {
  const [hasUpdate, setHasUpdate] = useState(false);
  const [newVersion, setNewVersion] = useState('');

  const checkVersion = useCallback(async () => {
    try {
      const response = await fetch(`/version.json?t=${Date.now()}`, {
        cache: 'no-store',
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      });

      if (response.ok) {
        const data = await response.json();
        const serverBuildNumber = data.buildNumber || data.timestamp;
        const localBuildNumber = localStorage.getItem(VERSION_STORAGE_KEY);

        if (!localBuildNumber) {
          localStorage.setItem(VERSION_STORAGE_KEY, serverBuildNumber.toString());
          return;
        }

        if (serverBuildNumber.toString() !== localBuildNumber) {
          console.log('Nova versão detectada. Atualizando aplicação...');
          setNewVersion(data.version || 'Nova versão');
          setHasUpdate(true);

          const token = localStorage.getItem('token');
          const user = localStorage.getItem('user');

          localStorage.clear();

          if (token) localStorage.setItem('token', token);
          if (user) localStorage.setItem('user', user);
          localStorage.setItem(VERSION_STORAGE_KEY, serverBuildNumber.toString());

          setTimeout(() => {
            reloadApp();
          }, AUTO_RELOAD_DELAY);
        }
      }
    } catch (error) {
      console.error('Erro ao verificar versão:', error);
    }
  }, []);

  const reloadApp = useCallback(() => {
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => caches.delete(name));
      });
    }

    window.location.reload();
  }, []);

  useEffect(() => {
    const initialCheck = setTimeout(() => {
      checkVersion();
    }, 2000);

    const interval = setInterval(checkVersion, CHECK_INTERVAL);

    const handleFocus = () => checkVersion();
    window.addEventListener('focus', handleFocus);

    return () => {
      clearTimeout(initialCheck);
      clearInterval(interval);
      window.removeEventListener('focus', handleFocus);
    };
  }, [checkVersion]);

  return { hasUpdate, newVersion, reloadApp };
};
